<div class="root-div">
  <div class="panel">
    <!-- app-roll-up move to report bottom toolbar as this function only available in report view for now  -->
    <!-- <app-roll-up></app-roll-up> -->
    <app-chat-bot-button></app-chat-bot-button>
  </div>
</div>
